import { FC, useCallback } from 'react';

import useCart from '@app/shop/hooks/useCart';
import { Button } from '@app/shop/components/Button';
import { GUEST_CART_ID_STORAGE_KEY } from '@app/shop/hooks/useCartId';

const CartRefreshButton: FC = () => {
  const { cartUserType } = useCart();
  const isGuest = cartUserType === 'guest';

  const handleClick = useCallback(() => {
    localStorage.removeItem(GUEST_CART_ID_STORAGE_KEY);
    window.location.reload();
  }, []);

  return isGuest ? (
    <Button type="secondary" onClick={handleClick}>
      New guest cart
    </Button>
  ) : null;
};

export default CartRefreshButton;
